import { Component } from '@angular/core';
import { IzzyTicketSuggestionEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Ticket Suggestions') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzyticketsuggestion-form',
    templateUrl: './izzyticketsuggestion.form.component.html'
})
export class IzzyTicketSuggestionFormComponent extends BaseFormComponent {
    public record!: IzzyTicketSuggestionEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'suggestionDetails', sectionName: 'Suggestion Details', isExpanded: true },
            { sectionKey: 'reporterContext', sectionName: 'Reporter Context', isExpanded: true },
            { sectionKey: 'classificationAnalysis', sectionName: 'Classification Analysis', isExpanded: true },
            { sectionKey: 'resolutionDetails', sectionName: 'Resolution Details', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false }
        ]);
    }
}

